import { styled } from '@mui/material';
import { Link } from 'react-router-dom';
import { CoreTypography } from '@youscience/core';

const linkHoverBg = '#EBF6F7';

export const StyledSwitcherWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'start',
  marginTop: '0.5rem',
  flexDirection: 'column',

  [theme.breakpoints.up('sm')]: {
    alignItems: 'center',
    flexDirection: 'row',
  },
}));

export const StyledExploreByTitle = styled(CoreTypography)(({ theme }) => ({
  marginTop: '3rem',
  marginRight: 0,
  marginBottom: '1rem',

  [theme.breakpoints.up('sm')]: {
    marginTop: 0,
    marginRight: '1.5rem',
    marginBottom: 0,
  },
}));

export const StyledSwitcher = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  maxHeight: '40px',
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: '2px',
  fontWeight: 600,
}));

interface StyledLinkProps {
  active: boolean;
}

export const StyledLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'active',
})<StyledLinkProps>(({ theme, active }) => ({
  padding: '0.438rem 1.25rem',
  color: active ? theme.palette.common.white : theme.palette.primary.main,
  backgroundColor: active ? theme.palette.primary.main : 'transparent',
  textDecoration: 'none',

  '&:hover': {
    backgroundColor: active ? theme.palette.primary.main : linkHoverBg,
    cursor: 'pointer',
  },

  '&:not(:last-of-type)': {
    borderRight: `1px solid ${theme.palette.primary.main}`,
  },
}));
